module.exports = __webpack_public_path__ + "img/15.82d3edd2.webp";